import React from 'react';

import { LanguageProvider } from './LanguageContext';
import { LayoutProvider } from './LayoutContext';
import { WebSocketProvider } from './WebSocketContext';
import { AuthProvider } from './AuthContext';
import { AiAssistantProvider } from './AiAssistantContext';

const defaultProviders = [
  LayoutProvider,
  WebSocketProvider,
  AuthProvider,
  LanguageProvider,
  AiAssistantProvider,
];

export default function CombinedContextProvider(providers = defaultProviders) {
  return providers.reduce(
    (AccumulateProviders, CurrentProvider) => {
      return ({ children }) => {
        return (
          <AccumulateProviders>
            <CurrentProvider>{children}</CurrentProvider>
          </AccumulateProviders>
        );
      };
    },
    ({ children }) => <>{children}</>,
  );
}
